import axios from 'axios';

const USER_TOKEN_KEY = 'deisycfit_token';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const isOwnApiCall = (url) => {
  if (!url.includes('/api/')) return false;
  // Solo nuestro backend: ruta relativa o la URL base configurada (no filtrar el token a terceros).
  return url.startsWith('/') || (BACKEND_URL && url.startsWith(BACKEND_URL));
};

// Adjunta el token del usuario a toda llamada /api/. No pisa un Authorization ya presente
// (pantallas que lo envían a mano, o el interceptor del admin) ni toca /api/admin/*.
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (!isOwnApiCall(url) || url.includes('/api/admin')) return config;
  let token = null;
  try { token = localStorage.getItem(USER_TOKEN_KEY); } catch (e) { /* storage bloqueado */ }
  if (!token) return config;
  config.headers = config.headers || {};
  const existing = typeof config.headers.get === 'function'
    ? config.headers.get('Authorization')
    : (config.headers.Authorization || config.headers.authorization);
  if (!existing) {
    if (typeof config.headers.set === 'function') config.headers.set('Authorization', `Bearer ${token}`);
    else config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Aviso global de sesión vencida/ inválida para que cada pantalla pueda mostrarlo.
export const isAuthError = (e) => e?.response?.status === 401;
